import { diasParaVencer } from '../contexts/AuthContext';

const DAY = 86400000;

export function diasDesde(value) {
  if (!value) return null;
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return null;
  return Math.max(0, Math.floor((Date.now() - date.getTime()) / DAY));
}

export function dataMaisRecente(items, fields = ['criadoEm', 'criado_em', 'data']) {
  return (items || []).reduce((latest, item) => {
    const raw = fields.map(field => item?.[field]).find(Boolean);
    const time = raw ? new Date(raw).getTime() : 0;
    return time > latest ? time : latest;
  }, 0) || null;
}

export function resumoAluna(aluna, data, extras = {}) {
  const treinos = (data.treinos || []).filter(item => item.alunaId === aluna.id);
  const dietas = (data.dietas || []).filter(item => item.alunaId === aluna.id);
  const checkins = (data.checkins || []).filter(item => item.alunaId === aluna.id);
  const agendamentos = (data.agendamentos || []).filter(item => item.alunaId === aluna.id);
  const exames = (data.exames || []).filter(item => item.alunaId === aluna.id);
  const feedbacks = (data.feedbacksTreino || []).filter(item => item.alunaId === aluna.id);
  const ultimoCheckin = dataMaisRecente(checkins);
  const diasSemTreino = ultimoCheckin ? diasDesde(ultimoCheckin) : null;
  const vencimento = diasParaVencer(aluna.inicioPlano, aluna.plano);
  const pendentes = agendamentos.filter(item => item.status === 'pendente');
  const proximo = agendamentos
    .filter(item => item.status !== 'cancelado' && new Date(`${item.data}T${item.horario || '00:00'}`) >= new Date())
    .sort((a, b) => new Date(`${a.data}T${a.horario || '00:00'}`) - new Date(`${b.data}T${b.horario || '00:00'}`))[0];

  const alerts = [];
  if (aluna.status === 'pausada') alerts.push({ level: 'neutral', type: 'acesso', text: 'Acesso pausado', action: 'Revisar acesso' });
  if (vencimento !== null && vencimento < 0) alerts.push({ level: 'danger', type: 'contrato', text: `Plano vencido há ${Math.abs(vencimento)} dias`, action: 'Tratar renovação' });
  else if (vencimento !== null && vencimento <= 7) alerts.push({ level: 'warning', type: 'contrato', text: vencimento === 0 ? 'Plano vence hoje' : `Plano vence em ${vencimento} dias`, action: 'Falar sobre renovação' });
  if (!treinos.length && aluna.acessoTreino !== false) alerts.push({ level: 'danger', type: 'treino', text: 'Sem treino cadastrado', action: 'Criar treino' });
  if (!dietas.length && aluna.acessoDieta !== false) alerts.push({ level: 'warning', type: 'nutricao', text: 'Sem plano alimentar', action: 'Criar plano' });
  if (diasSemTreino === null && treinos.length) alerts.push({ level: 'warning', type: 'checkin', text: 'Ainda não realizou nenhum check-in', action: 'Enviar mensagem' });
  else if (diasSemTreino >= 14) alerts.push({ level: 'danger', type: 'checkin', text: `Há ${diasSemTreino} dias sem treinar`, action: 'Entrar em contato' });
  else if (diasSemTreino >= 7) alerts.push({ level: 'warning', type: 'checkin', text: `Há ${diasSemTreino} dias sem treinar`, action: 'Acompanhar' });
  if (pendentes.length) alerts.push({ level: 'warning', type: 'agenda', text: `${pendentes.length} agendamento(s) pendente(s)`, action: 'Revisar agenda' });
  if (extras.mensagensNaoRespondidas > 0) alerts.push({ level: 'danger', type: 'mensagem', text: `${extras.mensagensNaoRespondidas} mensagem(ns) aguardando resposta`, action: 'Responder' });
  if (extras.questionariosPendentes > 0) alerts.push({ level: 'warning', type: 'questionario', text: `${extras.questionariosPendentes} questionário(s) pendente(s)`, action: 'Revisar saúde' });
  if (feedbacks.some(item => item.sentiu_dor || item.sentiuDor)) alerts.push({ level: 'danger', type: 'dor', text: 'Relato de dor em revisão de treino', action: 'Revisar treino' });

  const prioridade = alerts.reduce((score, alert) => score + (alert.level === 'danger' ? 3 : alert.level === 'warning' ? 2 : 1), 0);
  return { treinos, dietas, checkins, agendamentos, exames, feedbacks, ultimoCheckin, diasSemTreino, vencimento, proximo, alerts, prioridade };
}

export function formatarData(value, withYear = true) {
  if (!value) return '—';
  const date = new Date(value.length === 10 ? `${value}T12:00:00` : value);
  if (Number.isNaN(date.getTime())) return '—';
  return date.toLocaleDateString('pt-BR', { day: '2-digit', month: 'short', ...(withYear ? { year: 'numeric' } : {}) });
}
